<template>
  <div class="main-title-bar">
    <div class="main-title-bar-left">
      <button id="toggle-navicon" @click="toggleSidebar">
        <i class="fa-solid fa-bars"></i>
      </button>
      <h5 v-if="site">{{ site.siteTitle || site.uri }}</h5>
      <h5 v-else>Dynamic Builder</h5>
      <div class="top-menu-action-bar">
        <ul>
          <li>
            <!-- <a href="javascript:void(0);"><i class="fa-solid fa-gear"></i></a> -->
            <SiteSettings
              v-if="site && showSettings"
              :components="components"
              :title="site.siteTitle"
              :uri="site.uri"
              :isEditable="isEditable"
              :extFiles="site.extFiles"
              :fullReload="site.fullReload"
              :ajaxReload="site.ajaxReload"
              :loginInclude="site.loginInclude"
              :loginRequired="site.loginRequired"
              :extraAuths="site.extraAuths || []"
              :enableMobile="site.enableMobile"
              :enableIpad="site.enableIpad"
              :authUrl="site.authUrl"
              :authResponse="site.authResponse"
              :mobileQuery="site.mobileQuery"
              :authAPIMethod="site.authAPIMethod"
              :globalCss="site.globalCss"
              :globalJs="site.globalJs"
              :globalVariables="site.globalVariables || []"
              :hipaaConfig="site.hipaaConfig || { enabled: false, fields: ['email','name','ip','action','timestamp'], events: ['page_view','button_click','form_submit','login','logout'], button_log_mode: 'all', tracked_button_class: '' }"
              :hasPreviousState="hasPreviousState"
              :revertToPreviousState="revertToPreviousState"
              :isReverting="isReverting ? () => isReverting('globalCss') : null"
              v-bind="$attrs"
            />
          </li>
          <CustomTooltip text="Permission" placement="bottom">
            <a v-if="isSuperAdmin()" href="/site-permission"
              ><i class="fa-solid fa-user-shield mx-1.5"></i
            ></a>
          </CustomTooltip>
          <CustomTooltip text="View Site" placement="bottom">
            <span @click="openSitePage" class="pointer"
              ><i class="fa-solid fa-eye mx-1.5"></i
            ></span>
          </CustomTooltip>
          <!-- <li
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-title="Querystring"
            title="Querystring"
          >
            <a href="javascript:void(0);"
              ><i class="fa-solid fa-circle-question"></i
            ></a>
          </li> -->
          <CustomTooltip text="Save" placement="bottom">
            <span @click="$emit('save')" class="pointer save-blue-color"
              ><i class="fa-solid fa-floppy-disk mx-1.5"></i
            ></span>
          </CustomTooltip>
          <CustomTooltip 
            v-if="hasMultiplePreviousStates && hasMultiplePreviousStates()"
            :text="`Revert All Changes (${getAllPreviousStatesCount ? getAllPreviousStatesCount() : ''})`" 
            placement="bottom"
          >
            <span 
              @click="handleRevertAll" 
              class="pointer save-blue-color"
              :class="{ 'opacity-50 cursor-not-allowed': isReverting && isReverting() }"
              :style="{ pointerEvents: isReverting && isReverting() ? 'none' : 'auto' }"
            >
              <i class="fas fa-undo mx-1.5"></i>
            </span>
          </CustomTooltip>
        </ul>
      </div>
    </div>
    <!-- main-title-bar -->
    <div class="main-title-bar-right">
      <input
        :defaultValue="site.defaultQuery"
        type="text"
        class="query-string w-32 px-2"
        placeholder="query string"
        :id="`querystring`"
        @blur="isQueryInputFocused = false"
        @focus="isQueryInputFocused = true"
        :class="{ 'focused-input': isQueryInputFocused }"
        @change="$emit('update', { defaultQuery: $event.target.value })"
      />
      <select
        class="form-select"
        :value="selectedVersion"
        @change="$emit('selectVersion', $event.target.value)"
      >
        <!-- <option selected>2.0 Current Published</option>
        <option value="1">1.0</option> -->
        <option
          v-for="version of versionData.versions"
          :key="version"
          :value="version"
        >
          {{ version }}
          <small class="mx-2" v-if="version === versionData.current_version">
            current
          </small>
          <small class="mx-2" v-if="version === versionData.published_version">
            published
          </small>
        </option>
      </select>
      <div class="top-menu-action-bar">
        <ul>
          <li
            v-if="selectedVersion !== versionData.published_version"
            class="save-blue-color"
            @click="publishVersion"
          >
            <CustomTooltip text="Set as published version" placement="bottom">
              <a href="javascript:void(0);"><i class="fa-solid fa-gear"></i></a>
            </CustomTooltip>
          </li>
          <li
            v-if="selectedVersion !== versionData.current_version"
            @click="
              $emit('setMetaVersion', {
                current_version: selectedVersion,
              })
            "
          >
            <CustomTooltip text="Set as current version" placement="bottom">
              <a href="javascript:void(0);">
                <i class="fa-regular fa-pen-to-square"></i>
              </a>
            </CustomTooltip>
          </li>

          <li
            @click="openAddModal"
            :class="{ 'pointer-events-none opacity-60': loadingAdd }"
          >
            <CustomTooltip text="Add New Version" placement="bottom">
              <a href="javascript:void(0);">
                <i
                  class="fa-solid"
                  :class="loadingAdd ? 'fa-circle-notch fa-spin' : 'fa-copy'"
                ></i>
              </a>
            </CustomTooltip>
          </li>
          <li @click="openHistoryModal">
            <CustomTooltip text="Version History" placement="bottom">
              <a href="javascript:void(0);">
                <i class="fa-solid fa-clock-rotate-left"></i>
              </a>
            </CustomTooltip>
          </li>

          <li v-if="showImport" @click="$emit('importVersion')">
            <CustomTooltip text="Import Version" placement="bottom">
              <a href="javascript:void(0);" class="import-version-action">
                <svg
                  class="import-version-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z" />
                  <polyline points="14 2 14 7 19 7" />
                  <path d="M3 12h8" />
                  <path d="M8 8l4 4-4 4" />
                </svg>
              </a>
            </CustomTooltip>
          </li>
          <li
            v-if="
              ![
                versionData.published_version,
                versionData.current_version,
              ].includes(selectedVersion)
            "
            @click="openDeleteModal"
          >
            <CustomTooltip text="Delete" placement="bottom">
              <a href="javascript:void(0);">
                <i class="fa-solid fa-trash-can delete-version"></i>
              </a>
            </CustomTooltip>
          </li>
        </ul>
      </div>
      <AddVersionModal
        :isVisible="showAddModal"
        :existingVersions="allKnownVersions"
        :sourceVersion="selectedVersion"
        :submitting="submittingAdd"
        @update:isVisible="showAddModal = $event"
        @cancel="showAddModal = false"
        @confirm="handleAddConfirm"
      />
      <DeleteVersionModal
        :isVisible="showDeleteModal"
        :version="deleteTargetVersion || selectedVersion"
        :submitting="submittingDelete"
        @update:isVisible="onDeleteModalVisibility"
        @cancel="onDeleteModalCancel"
        @confirm="handleDeleteConfirm"
      />
      <VersionHistoryModal
        :isVisible="showHistoryModal"
        :history="versionHistory"
        :loading="historyLoading"
        @update:isVisible="showHistoryModal = $event"
        @requestDelete="handleHistoryDeleteRequest"
        @selectVersion="$emit('selectVersion', $event)"
      />
      <a
        @click="logout"
        href="javascript:void(0);"
        class="btn btn-default btn-black ck"
        ><i class="fa-solid fa-power-off"></i> Logout</a
      >
    </div>
    <!-- main-title-bar-right -->
  </div>
  <!-- main-title-bar -->
</template>
<script>
import * as authService from "../service/auth";
import * as siteService from "../service/site";
import SiteSettings from "../components/SiteSettings.vue";
import AddVersionModal from "../components/AddVersionModal.vue";
import DeleteVersionModal from "../components/DeleteVersionModal.vue";
import VersionHistoryModal from "../components/VersionHistoryModal.vue";
import { viewer_url } from "../constants";
import CustomTooltip from "@/utilities/CustomTooltip.vue";

export default {
  name: "PageHeader",
  components: {
    SiteSettings,
    CustomTooltip,
    AddVersionModal,
    DeleteVersionModal,
    VersionHistoryModal,
  },
  props: {
    site: {
      type: Object,
      default: () => null,
    },
    components: {
      type: Array,
      default: () => [],
    },
    showSettings: {
      type: Boolean,
      default: true,
    },
    versionData: {
      type: Object,
      default: () => ({
        versions: [],
      }),
    },
    selectedVersion: String,
    isListPage: {
      type: Boolean,
      default: false,
    },
    showImport: {
      type: Boolean,
      default: false,
    },
    hasPreviousState: {
      type: Function,
      default: null,
    },
    revertToPreviousState: {
      type: Function,
      default: null,
    },
    hasMultiplePreviousStates: {
      type: Function,
      default: null,
    },
    revertAllPreviousStates: {
      type: Function,
      default: null,
    },
    getAllPreviousStatesCount: {
      type: Function,
      default: null,
    },
    isReverting: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isQueryInputFocused: false,
      showAddModal: false,
      showDeleteModal: false,
      showHistoryModal: false,
      submittingAdd: false,
      submittingDelete: false,
      loadingAdd: false,
      historyLoading: false,
      versionHistory: [],
      deleteTargetVersion: null,
      deleteFromHistory: false,
    };
  },
  computed: {
    allKnownVersions() {
      const live = (this.versionData?.versions) || [];
      const fromHistory = (this.versionHistory || []).map(h => h.version).filter(Boolean);
      return Array.from(new Set([...live, ...fromHistory]));
    },
  },
  mounted() {
    if (this.site && this.site.uri) {
      this.$emit("update", { name: this.site.uri });
    }
  },
  methods: {
    openSitePage() {
      const { uri } = this.$route.params;
      const query = document.querySelector(`#querystring`).value;
      const url = `${viewer_url}/${uri}?${query}${query ? "&" : ""}v=${
        this.selectedVersion
      }`;
      window.open(url, "_blank");
    },
    async logout() {
      await authService.logoutApi();
      window.location.href = "/login";
    },
    isSuperAdmin() {
      const user = authService.getUser();
      return user && user.is_super_admin;
    },
    async publishVersion() {
      if (window.confirm("Are you sure want to publish this version?")) {
        this.$emit("setMetaVersion", {
          published_version: this.selectedVersion,
        });
      }
    },
    async openAddModal() {
      if (this.loadingAdd) return;
      this.loadingAdd = true;
      try {
        await this.loadVersionHistory();
        this.showAddModal = true;
      } finally {
        this.loadingAdd = false;
      }
    },
    openDeleteModal() {
      this.deleteTargetVersion = this.selectedVersion;
      this.deleteFromHistory = false;
      this.showDeleteModal = true;
    },
    async loadVersionHistory() {
      const uri = this.$route?.params?.uri;
      if (!uri) return;
      this.historyLoading = true;
      try {
        const res = await siteService.getVersionHistory(uri);
        this.versionHistory = res?.history || [];
      } catch (err) {
        this.$notify({ type: "warn", text: `Failed to load history: ${err}` });
      } finally {
        this.historyLoading = false;
      }
    },
    async openHistoryModal() {
      this.showHistoryModal = true;
      await this.loadVersionHistory();
    },
    handleHistoryDeleteRequest(version) {
      this.deleteTargetVersion = version;
      this.deleteFromHistory = true;
      this.showDeleteModal = true;
    },
    onDeleteModalVisibility(visible) {
      this.showDeleteModal = visible;
      if (!visible) this.deleteTargetVersion = null;
    },
    onDeleteModalCancel() {
      this.showDeleteModal = false;
      this.deleteTargetVersion = null;
    },
    async handleAddConfirm({ newVersion, note }) {
      this.submittingAdd = true;
      try {
        await new Promise((resolve, reject) => {
          this.$emit("addNewVersion", {
            newVersion,
            note,
            onSuccess: resolve,
            onError: reject,
          });
        });
        this.showAddModal = false;
      } catch (err) {
        // Error notification is handled by the parent; modal stays open.
      } finally {
        this.submittingAdd = false;
      }
    },
    async handleDeleteConfirm({ deleteNote }) {
      const version = this.deleteTargetVersion || this.selectedVersion;
      const fromHistory = this.deleteFromHistory;
      this.submittingDelete = true;
      try {
        await new Promise((resolve, reject) => {
          this.$emit("deleteVersion", {
            version,
            deleteNote,
            skipReload: fromHistory && version !== this.selectedVersion,
            onSuccess: resolve,
            onError: reject,
          });
        });
        this.showDeleteModal = false;
        this.deleteTargetVersion = null;
        this.deleteFromHistory = false;
        if (this.showHistoryModal) {
          await this.loadVersionHistory();
        }
      } catch (err) {
        // Parent surfaces the error; modal stays open.
      } finally {
        this.submittingDelete = false;
      }
    },
    toggleSidebar() {
      this.$emit("toggleSidebar");
    },
    handleRevertAll() {
      if (this.revertAllPreviousStates) {
        this.revertAllPreviousStates();
      }
    },
  },
};
</script>
<style scoped>
.delete-version {
  color: red !important;
}
.import-version-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;
}
.import-version-icon {
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
}
.main-title-bar-right .top-menu-action-bar ul > li {
  display: flex;
  align-items: center;
}
.query-string {
  border-radius: 19px;
  background-color: #ffffff;
  border: 1px solid #ededff;
  box-shadow: none !important;
  font-size: 14px;
  height: 36px;
  outline: none;
}
.focused-input {
  max-width: 11em !important;
  width: 100%;
}
</style>